// Your web app's Firebase configuration

import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from 'firebase/app'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyAt8K8qauld9QD1qIwmfQ7D8C20kUu1Ocg',
  authDomain: 'kfamily-website.firebaseapp.com',
  projectId: 'kfamily-website',
  storageBucket: 'kfamily-website.firebasestorage.app',
  messagingSenderId: '345192245767',
  appId: '1:345192245767:web:079784f6a6d5a3cdb8d8a2',
  measurementId: 'G-W4XRV1R2KF',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const analytics = getAnalytics(app)

export default { app, analytics }
